export enum Direction {
  left = -1,
  right = 1,
}
